import { render, staticRenderFns } from "./topbar.vue?vue&type=template&id=5de2f09d"
import script from "./topbar.vue?vue&type=script&lang=ts"
export * from "./topbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports